import { ReloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import StickyPageHeader from '../components/common/StickyPageHeader';
import AuditRatesList from '../components/lists/AuditRatesList';
import { useCarriers, useRateAuditSummary } from '../hooks/apiHooks';
import Layout from '../layout';

const AdminAuditRatesPage = ({ disableLayout, routes }) => {
  const { allCarriers } = useCarriers();
  const { isLoading, refetch } = useRateAuditSummary();

  const handleRefresh = () => {
    refetch();
  };

  const content = (
    <>
      <StickyPageHeader
        isAdmin
        actions={
          <Button
            icon={<ReloadOutlined />}
            loading={isLoading}
            onClick={handleRefresh}
          >
            Refresh
          </Button>
        }
        title="Audit Rates"
      />
      <AuditRatesList carriers={allCarriers} />
    </>
  );

  if (disableLayout) return content;

  return (
    <Layout
      showCarriersNavigation
      disableLoading={true}
      menuIndex={0}
      routes={routes}
    >
      {content}
    </Layout>
  );
};

export default AdminAuditRatesPage;
